import { render, staticRenderFns } from "./color-scheme-select.vue?vue&type=template&id=2e11274a&scoped=true"
import script from "./color-scheme-select.vue?vue&type=script&lang=js"
export * from "./color-scheme-select.vue?vue&type=script&lang=js"
import style0 from "./color-scheme-select.vue?vue&type=style&index=0&id=2e11274a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e11274a",
  null
  
)

export default component.exports